import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

import {Workspace} from "../../../../model/workspace.data";
import {ScannerTrialPopupMobile} from "./ScannerTrialPopupMobile.component";
import {ScannerTrialPopup} from "../ScannerTrialPopup/ScannerTrialPopupModal.component";



export function showScannerTrialPopuMobileModal(modalService: NgbModal, workspace: Workspace, mobileMode: string = 'desktop') {


    if(!workspace.IsScannerTrialExpired) {

        const mobile = mobileMode != 'desktop';
        const component =  mobile? ScannerTrialPopupMobile: ScannerTrialPopupMobile;

        const windowClass = "dark-modal largeWindow" + (mobile ? ' mobile' : '');
        
        let m: NgbModalRef = modalService.open(component, {
            backdrop: "static",
            size: "lg",
            centered: true,
            windowClass: windowClass
        });
        let modal = (<ScannerTrialPopupMobile> m.componentInstance);
        return modal;

    } else {
        return null;
    }
}
